export const SITE = {
  name: "Begin Again Living Ministries",
  short: "Begin Again Living",
  tagline: "Helping People Begin Again After Loss, Grief, and Life's Hardest Seasons",
  email: "office@balministries.org",
  address: {
    line1: "P.O. Box 1904",
    line2: "Lincoln, CA 95648",
  },
  disclaimer:
    "Begin Again Living Ministries provides faith-based encouragement, education, spiritual care support, and grief resources. Services are not a substitute for licensed medical, mental health, legal, or financial care.",
};

// Header navigation configuration.
// - `type: "link"` renders as a plain top-level link.
// - `type: "dropdown"` renders as a top-level trigger that opens a submenu on
//   hover, focus, click, or keyboard activation. If `to` is provided, the
//   parent label is also a clickable link to that route (Enter opens the page,
//   ArrowDown / click opens the submenu).
// Anchor-style destinations (e.g. `/classes#online-chapel`) are supported and
// will smooth-scroll to the target section via `Layout.jsx`.
// `id` is used to generate stable data-testid values.
export const NAV_MENU = [
  { type: "link", id: "home", to: "/", label: "Home" },
  {
    type: "dropdown",
    id: "fd2g",
    label: "From Diagnosis to Goodbye",
    to: "/from-diagnosis-to-goodbye",
    items: [
      { id: "fd2g-book", to: "/from-diagnosis-to-goodbye", label: "The Book & Series" },
      { id: "fd2g-books-publications", to: "/books", label: "Books & Publications" },
      { id: "fd2g-workbooks", to: "/books#companions", label: "Guided Workbooks" },
      { id: "fd2g-facilitator", to: "/books#professional", label: "Facilitator & Training Materials" },
      { id: "fd2g-bulk", to: "/bulk-orders", label: "Bulk Orders" },
      { id: "fd2g-sponsor", to: "/sponsor-a-book", label: "Sponsor a Book" },
    ],
  },
  {
    type: "dropdown",
    id: "grief-support",
    label: "Grief & Support",
    to: "/grief-support",
    items: [
      { id: "gs-overview", to: "/grief-support", label: "Grief & Support Overview" },
      { id: "gs-classes", to: "/classes", label: "Classes & Online Support" },
      { id: "gs-hospice", to: "/classes#hospice-family-support", label: "Hospice Family Support" },
      { id: "gs-bereavement", to: "/classes#bereavement-support", label: "Bereavement Support" },
      { id: "gs-chapel", to: "/classes#online-chapel", label: "Online Chapel" },
      { id: "gs-request", to: "/request-support", label: "Request Support" },
      { id: "gs-sponsor-a-book", to: "/sponsor-a-book", label: "Sponsor a Book" },
    ],
  },
  {
    type: "dropdown",
    id: "for-orgs",
    label: "For Organizations",
    to: "/organization-bookings",
    items: [
      { id: "org-request", to: "/organization-bookings", label: "Request a Date & Program" },
      { id: "org-workshops", to: "/classes#classes-workshops", label: "Workshops & Speaking" },
      { id: "org-facilitator", to: "/books#professional", label: "Facilitator & Training Materials" },
    ],
  },
  {
    type: "dropdown",
    id: "resources",
    label: "Resources",
    items: [
      { id: "res-free", to: "/resources", label: "Free Resources" },
      { id: "res-ask", to: "/ask-chaplain-derrick", label: "Ask Chaplain Derrick" },
    ],
  },
  { type: "link", id: "about", to: "/about", label: "About" },
  { type: "link", id: "contact", to: "/contact", label: "Contact" },
];

// Flat list used by the Footer "Explore" column. Curated (not every leaf) to
// stay compact and mirror the primary destinations visitors reach for.
export const NAV = [
  { to: "/", label: "Home" },
  { to: "/about", label: "About" },
  { to: "/from-diagnosis-to-goodbye", label: "From Diagnosis to Goodbye" },
  { to: "/books", label: "Books & Publications" },
  { to: "/grief-support", label: "Grief & Support" },
  { to: "/classes", label: "Classes & Online Support" },
  { to: "/request-support", label: "Request Support" },
  { to: "/organization-bookings", label: "For Organizations" },
  { to: "/resources", label: "Free Resources" },
  { to: "/ask-chaplain-derrick", label: "Ask Chaplain Derrick" },
  { to: "/contact", label: "Contact" },
  { to: "/donate", label: "Donate" },
];

export const IMAGES = {
  hero: "https://images.unsplash.com/photo-1750905959822-d31b2c2754b7?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxODh8MHwxfHNlYXJjaHwxfHxwZWFjZWZ1bCUyMHN1bnJpc2UlMjBsYW5kc2NhcGUlMjBob3BlfGVufDB8fHx8MTc3ODQ0MjA5MHww&ixlib=rb-4.1.0&q=85",
  reflection:
    "https://images.unsplash.com/photo-1763899910806-43a13994b44f?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzMzl8MHwxfHNlYXJjaHwxfHxwZXJzb24lMjByZWZsZWN0aW5nJTIwcGVhY2VmdWwlMjBuYXR1cmV8ZW58MHx8fHwxNzc4NDQyMDkwfDA&ixlib=rb-4.1.0&q=85",
  conversation:
    "https://images.unsplash.com/photo-1765896387398-1e1ae8d2eb85?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDQ2NDF8MHwxfHNlYXJjaHwxfHxzdXBwb3J0aXZlJTIwY29udmVyc2F0aW9uJTIwY29tcGFzc2lvbmF0ZXxlbnwwfHx8fDE3Nzg0NDIwOTB8MA&ixlib=rb-4.1.0&q=85",
  counseling:
    "https://images.unsplash.com/photo-1758273240403-052b3c99f636?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2ODh8MHwxfHNlYXJjaHwyfHxjb3Vuc2VsaW5nJTIwc3VwcG9ydCUyMGNhcmluZ3xlbnwwfHx8fDE3Nzg0NDIwOTV8MA&ixlib=rb-4.1.0&q=85",
  // Additional curated supportive imagery (Unsplash)
  prayingHands:
    "https://images.unsplash.com/photo-1499209974431-9dddcece7f88?auto=format&fit=crop&w=1600&q=80",
  candle:
    "https://images.unsplash.com/photo-1518911710364-17ec553bde5d?auto=format&fit=crop&w=1600&q=80",
  bibleHands:
    "https://images.unsplash.com/photo-1504052434569-70ad5836ab65?auto=format&fit=crop&w=1600&q=80",
  forestLight:
    "https://images.unsplash.com/photo-1448375240586-882707db888b?auto=format&fit=crop&w=1600&q=80",
  community:
    "https://images.unsplash.com/photo-1529156069898-49953e39b3ac?auto=format&fit=crop&w=1600&q=80",
  caregiver:
    "https://images.unsplash.com/photo-1576765608535-5f04d1e3f289?auto=format&fit=crop&w=1600&q=80",
  journal:
    "https://images.unsplash.com/photo-1455390582262-044cdead277a?auto=format&fit=crop&w=1600&q=80",
  walking:
    "https://images.unsplash.com/photo-1518609878373-06d740f60d8b?auto=format&fit=crop&w=1600&q=80",
  // Online community / Zoom-style imagery for Online Chapel
  // Laptop on a warm wooden desk with a Zoom-style video-call grid filling the screen,
  // a mug beside it — communicates "people connecting online for support" without any
  // corporate / high-five / church-building stock photo clichés.
  chapel:
    "https://images.unsplash.com/photo-1588196749597-9ff075ee6b5b?auto=format&fit=crop&w=1600&q=80",
  chapelAlt:
    "https://images.unsplash.com/photo-1573497019940-1c28c88b4f3e?auto=format&fit=crop&w=1600&q=80",
  // Soft, warm podcast / microphone imagery for the Ask Chaplain Derrick page.
  // Studio mic on a clean desk, naturally lit — modern media-brand feel
  // without flashy podcast graphics or neon palettes.
  podcastMic:
    "https://images.unsplash.com/photo-1590602847861-f357a9332bbc?auto=format&fit=crop&w=1600&q=80",
  podcastHeadphones:
    "https://images.unsplash.com/photo-1505740420928-5e560c06d30e?auto=format&fit=crop&w=1600&q=80",
};

export const API_BASE = `${process.env.REACT_APP_BACKEND_URL}/api`;
